import React from "react";
import BranchReport from "../Branch Report/Report";
import HeadOfficeReport from "../Head Office Report/Report";
import secureLocalStorage from "react-secure-storage";
import "./style.css";
import { Helmet } from "react-helmet-async";

export default function Report() {
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  return (
    <div>
      <Helmet title='Report | Advice' />
      {user.results.branch === "head office" ? (
        <HeadOfficeReport />
      ) : (
        <BranchReport />
      )}
    </div>
  );
}
